import React, { useEffect } from "react";
import { Capacitor } from '@capacitor/core';

function LandingPage() {
  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      window.location.replace('/login');
    }
  }, [])
  return (
    <>
      <style>{css}</style>
      <div className="landing-wrapper">
        
        {/* Navbar */}
        <nav className="navbar slide-down">
          <a href="/" className="nav-logo">
            <img src="/9211c075-087c-42b4-9f8d-c9c592607ca3.jpg" alt="MealBee" className="logo-image bounce-hover" />
          </a>
          <div className="nav-links">
            <a href="#features" className="hover-underline">Features</a>
            <a href="#partners" className="hover-underline">Partners</a>
            <a href="#download" className="hover-underline">Download</a>
            <a href="/login" className="nav-admin-btn pulse-glow">Admin Login</a>
          </div>
        </nav>

        {/* Hero Section */}
        <header className="hero-section">
          <div className="hero-bg-animated"></div>
          
          {/* Multi-Food Particle Animation Cluster */}
          <div className="floating-foods-container">
            <span className="food-icon f-1">🍔</span>
            <span className="food-icon f-2">🍟</span>
            <span className="food-icon f-3">🥤</span>
            <span className="food-icon f-4">🌮</span>
            <span className="food-icon f-5">🍩</span>
            <span className="food-icon f-6">🍣</span>
            <span className="food-icon f-7">🍕</span>
            <span className="food-icon f-8">🧁</span>
          </div>

          <div className="hero-content fade-in-up">
            <div className="badge-pill">🚀 Your localFood Delivery</div>
            
            <div className="hero-video-container">
               <img 
                 src="/9211c075-087c-42b4-9f8d-c9c592607ca3.jpg" 
                 alt="MealBee" 
                 className="hero-video"
               />
            </div>
            <h1 className="hero-title">
              Food Delivered <br/>
              <span className="text-gradient-animate">Fast & Fresh</span>
            </h1>
            <p className="hero-subtitle delay-1">
              Order from your favorite local restaurants and get hot, delicious food delivered straight to your doorstep in minutes.
            </p>
            <div className="hero-buttons delay-2">
              <a href="#download" className="btn btn-dark shiny-btn">
                <span>📱 Download App</span>
              </a>
              <a href="#partners" className="btn btn-glass shiny-btn-light">
                <span>🤝 Become a Partner</span>
              </a>
            </div>
          </div>
          
          {/* Decorative bottom wave */}
          <div className="wave-bottom">
            <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z" className="shape-fill"></path>
            </svg>
          </div>
        </header>

        {/* Features Section */}
        <section id="features" className="section bg-white fade-in-scroll">
          <div className="section-container">
            <h2 className="section-title reveal-text">Why Choose MealBee?</h2>
            <div className="features-grid">
              <FeatureCard
                icon="⚡"
                title="Lightning Fast"
                text="Our delivery partners ensure your food arrives piping hot."
                delay="0.1s"
              />
              <FeatureCard
                icon="🗺️"
                title="Live Tracking"
                text="Know exactly where your order is with real-time map tracking."
                delay="0.2s"
              />
              <FeatureCard
                icon="🛡️"
                title="Secure Payments"
                text="Pay easily via UPI, Credit Cards, Net Banking, or COD."
                delay="0.3s"
              />
              <FeatureCard
                icon="🎉"
                title="Exclusive Offers"
                text="Enjoy daily discounts, free delivery, and special coupons."
                delay="0.4s"
              />
            </div>
          </div>
        </section>

        {/* Why Bakalia Section */}
        <section className="section bg-orange-pattern fade-in-scroll">
          <div className="section-container">
            <div className="why-bakalia-container animated-card delay-1">
              <div className="mission-badge">Our Mission</div>
              <h2 className="mission-title">Why We Brought MealBee to Bakalia</h2>
              <p className="mission-text">
                For too long, the convenience of lightning-fast food delivery has been limited to metropolitan cities. We believe <strong>Bakalia deserves better.</strong>
              </p>
              <p className="mission-text">
                MealBee was born out of a desire to connect our vibrant community. We are here to empower Bakalia's amazing local restaurants by giving them a digital storefront, create flexible earning opportunities for our youth, and most importantly, deliver happiness directly to your doorstep.
              </p>
              <p className="mission-highlight">
                Local food. Local people. Metropolitan convenience.
              </p>
            </div>
          </div>
        </section>

        {/* Partners Section */}
        <section id="partners" className="section bg-gradient-light fade-in-scroll">
          <div className="section-container">
            <h2 className="section-title reveal-text">Grow With MealBee</h2>
            <div className="partners-grid">
              <PartnerCard
                emoji="🏪"
                title="Restaurant Partners"
                text="Reach thousands of new hungry customers. Increase your orders and grow your revenue effortlessly."
                btnText="Register Restaurant"
                link="/restaurant-register"
                delay="0.1s"
              />
              <PartnerCard
                emoji="🚴"
                title="Delivery Partners"
                text="Earn money with flexible working hours. Be your own boss and get paid weekly."
                btnText="Join as Rider"
                link="/delivery-register"
                delay="0.3s"
              />
            </div>
          </div>
        </section>

        {/* 🟢 UPDATED: Download Section with Google Play Store Link */}
        <section id="download" className="section bg-white text-center fade-in-scroll">
          <div className="section-container download-container hover-lift">
            <div className="download-blob"></div>
            <h2 className="section-title" style={{ marginBottom: '16px' }}>Ready to Order?</h2>
            <p className="download-subtitle">Install the MealBee app now to get <strong>free delivery</strong> on your first order!</p>
            
            <a 
              href="https://play.google.com/store/apps/details?id=com.mealbee.app&hl=en" 
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary btn-large bouncy-btn shiny-btn"
            >
              <span>📱 Download on Google Play</span>
            </a>
          </div>
        </section>

        {/* Footer */}
        <footer className="footer slide-up">
          <div className="footer-content">
            <img src="/9211c075-087c-42b4-9f8d-c9c592607ca3.jpg" alt="MealBee" className="footer-logo-image" />
            <p className="footer-email hover-text-glow">support@mealbee.in</p>
            <div className="footer-links">
              <a href="/privacy-policy">Privacy Policy</a>
              <span className="dot">·</span>
              <a href="/terms">Terms & Conditions</a>
              <span className="dot">·</span>
              <a href="/refund-policy">Refund Policy</a>
            </div>
            <p className="footer-copyright">© {new Date().getFullYear()} MealBee Technologies. All rights reserved.</p>
          </div>
        </footer>

      </div>
    </>
  );
}

/* Sub-Components */
function FeatureCard({ icon, title, text, delay }) {
  return (
    <div className="feature-card animated-card" style={{ animationDelay: delay }}>
      <div className="feature-icon icon-pop">{icon}</div>
      <h3 className="feature-title">{title}</h3>
      <p className="feature-text">{text}</p>
      <div className="card-glow"></div>
    </div>
  );
}

function PartnerCard({ emoji, title, text, btnText, link, delay }) {
  return (
    <div className="partner-card animated-card glass-card" style={{ animationDelay: delay }}>
      <div className="partner-emoji floating-fast">{emoji}</div>
      <h3 className="partner-title">{title}</h3>
      <p className="partner-text">{text}</p>
      <a href={link} className="btn-text group">
        {btnText} <span className="arrow-move">→</span>
      </a>
      <div className="card-glow-orange"></div>
    </div>
  );
}


/* ── Modern Premium CSS with Intensive Animations ── */
const css = `
  /* Resets & Base Variables */
  html { scroll-behavior: smooth; }
  body, html {
    margin: 0; padding: 0;
    font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    color: #1c1c1c; background: #ffffff;
    overflow-x: hidden;
  }

  /* Animations Definitions */
  @keyframes gradientBG {
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
  }
  @keyframes fadeInUp {
    from { opacity: 0; transform: translateY(40px); }
    to { opacity: 1; transform: translateY(0); }
  }
  @keyframes slideDown {
    from { opacity: 0; transform: translateY(-100%); }
    to { opacity: 1; transform: translateY(0); }
  }
  @keyframes scaleUp {
    from { opacity: 0; transform: scale(0.8); }
    to { opacity: 1; transform: scale(1); }
  }
  @keyframes shine {
    0% { left: -100%; top: -100%; }
    20% { left: 200%; top: 200%; }
    100% { left: 200%; top: 200%; }
  }
  @keyframes pulseGlow {
    0% { box-shadow: 0 0 0 0 rgba(255, 107, 0, 0.4); }
    70% { box-shadow: 0 0 0 15px rgba(255, 107, 0, 0); }
    100% { box-shadow: 0 0 0 0 rgba(255, 107, 0, 0); }
  }
  @keyframes textGradient {
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
  }

  /* Multi-Food Drift Animations */
  @keyframes floatDrift1 {
    0%, 100% { transform: translateY(0) rotate(0deg) translateX(0); }
    33% { transform: translateY(-30px) rotate(15deg) translateX(20px); }
    66% { transform: translateY(20px) rotate(-10deg) translateX(-15px); }
  }
  @keyframes floatDrift2 {
    0%, 100% { transform: translateY(0) rotate(0deg) translateX(0); }
    33% { transform: translateY(30px) rotate(-20deg) translateX(-25px); }
    66% { transform: translateY(-25px) rotate(10deg) translateX(20px); }
  }
  @keyframes floatFast {
    0%, 100% { transform: translateY(0px); }
    50% { transform: translateY(-10px); }
  }

  /* Utility Animation Classes */
  .fade-in-up { animation: fadeInUp 1s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
  .slide-down { animation: slideDown 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
  .scale-up { animation: scaleUp 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards; opacity: 0; }
  .delay-1 { animation-delay: 0.2s; opacity: 0; animation-fill-mode: forwards; }
  .delay-2 { animation-delay: 0.4s; opacity: 0; animation-fill-mode: forwards; }
  .floating-fast { animation: floatFast 3s ease-in-out infinite; }
  .pulse-glow { animation: pulseGlow 2s infinite; }

  /* Logo Image Stylings */
  .logo-image {
    height: 45px; width: auto; object-fit: contain; border-radius: 8px;
  }
  .footer-logo-image {
    height: 80px; width: auto; object-fit: contain; margin-bottom: 20px; border-radius: 12px;
  }

  /* Navbar (Frosted Glass) */
  .navbar {
    display: flex; justify-content: space-between; align-items: center;
    padding: 16px 5%;
    background: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(20px); -webkit-backdrop-filter: blur(20px);
    position: sticky; top: 0; z-index: 1000;
    border-bottom: 1px solid rgba(255,255,255,0.3);
    box-shadow: 0 4px 30px rgba(0,0,0,0.03);
  }
  .nav-logo { display: flex; align-items: center; gap: 8px; text-decoration: none; }
  .bounce-hover { display: inline-block; transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275); }
  .nav-logo:hover .bounce-hover { transform: scale(1.1) rotate(-5deg); }
  
  .nav-links { display: flex; align-items: center; gap: 32px; }
  .nav-links a {
    text-decoration: none; color: #1c1c1c; font-weight: 600; font-size: 15px;
    position: relative; padding: 4px 0;
  }
  .hover-underline::after {
    content: ''; position: absolute; width: 0; height: 2px;
    bottom: 0; left: 0; background-color: #ff6b00; transition: width 0.3s ease;
  }
  .hover-underline:hover::after { width: 100%; }
  
  .nav-admin-btn {
    background: linear-gradient(135deg, #fff0e6, #ffe0cc);
    color: #ff6b00 !important; padding: 10px 20px !important;
    border-radius: 12px; font-weight: 800 !important;
    transition: transform 0.2s, box-shadow 0.2s;
  }
  .nav-admin-btn:hover { transform: translateY(-2px); box-shadow: 0 4px 15px rgba(255,107,0,0.2); }

  /* Hero Section */
  .hero-section {
    position: relative; min-height: 90vh;
    display: flex; align-items: center; justify-content: center;
    text-align: center; padding: 40px 5%; overflow: hidden;
  }
  .hero-bg-animated {
    position: absolute; top: 0; left: 0; right: 0; bottom: 0;
    background: linear-gradient(-45deg, #ff8a00, #ff5200, #ff2a00, #ff9d00);
    background-size: 400% 400%;
    animation: gradientBG 15s ease infinite;
    z-index: 0;
  }

  /* Floating Foods Container & Icons */
  .floating-foods-container {
    position: absolute; top: 0; left: 0; width: 100%; height: 100%;
    overflow: hidden; pointer-events: none; z-index: 5;
  }
  .food-icon {
    position: absolute; 
    filter: drop-shadow(0 15px 25px rgba(0,0,0,0.25));
    opacity: 0.85;
  }
  
  /* Scattering the 8 icons across the screen with varying sizes, speeds, and directions */
  .f-1 { top: 15%; left: 8%; font-size: 45px; animation: floatDrift1 9s ease-in-out infinite; }
  .f-2 { top: 65%; left: 12%; font-size: 60px; animation: floatDrift2 12s ease-in-out infinite 2s; }
  .f-3 { top: 25%; left: 85%; font-size: 55px; animation: floatDrift1 10s ease-in-out infinite 1s; }
  .f-4 { top: 75%; left: 82%; font-size: 70px; animation: floatDrift2 14s ease-in-out infinite 3s; }
  .f-5 { top: 12%; left: 55%; font-size: 50px; animation: floatDrift2 11s ease-in-out infinite 1.5s; }
  .f-6 { top: 85%; left: 45%; font-size: 65px; animation: floatDrift1 13s ease-in-out infinite 0.5s; }
  .f-7 { top: 40%; left: 22%; font-size: 75px; animation: floatDrift1 15s ease-in-out infinite 2.5s; }
  .f-8 { top: 45%; left: 72%; font-size: 40px; animation: floatDrift2 10s ease-in-out infinite 3.5s; }

  /* Video Logo in Hero */
  .hero-video-container {
    margin: 0 auto 20px auto; width: 200px; height: 200px; border-radius: 50%; overflow: hidden;
    background: white; box-shadow: 0 15px 35px rgba(0,0,0,0.2);
  }
  .hero-video { width: 100%; height: 100%; object-fit: cover; }
  
  .hero-content { position: relative; z-index: 10; max-width: 850px; }
  .badge-pill {
    display: inline-block; background: rgba(255,255,255,0.2); backdrop-filter: blur(10px);
    border: 1px solid rgba(255,255,255,0.4); padding: 8px 16px; border-radius: 30px;
    color: white; font-weight: 700; font-size: 14px; margin-bottom: 24px;
    box-shadow: 0 4px 15px rgba(0,0,0,0.1);
  }
  .hero-title {
    font-size: clamp(44px, 7vw, 76px); font-weight: 900; line-height: 1.1; margin-bottom: 24px;
    letter-spacing: -1.5px; color: #ffffff; text-shadow: 0 10px 30px rgba(0,0,0,0.1);
  }
  .text-gradient-animate {
    background: linear-gradient(to right, #ffffff, #ffe0cc, #ffffff); background-size: 200% auto;
    color: #000; background-clip: text; text-fill-color: transparent; -webkit-background-clip: text; -webkit-text-fill-color: transparent;
    animation: textGradient 3s linear infinite;
  }
  .hero-subtitle {
    font-size: clamp(16px, 2vw, 22px); font-weight: 500; color: rgba(255,255,255,0.95);
    margin: 0 auto 40px auto; max-width: 650px; line-height: 1.6;
  }
  .hero-buttons { display: flex; gap: 20px; justify-content: center; flex-wrap: wrap; }
  
  .wave-bottom { position: absolute; bottom: -1px; left: 0; width: 100%; overflow: hidden; line-height: 0; z-index: 10; }
  .wave-bottom svg { display: block; width: calc(130% + 1.3px); height: 80px; transform: rotateY(180deg); }
  .wave-bottom .shape-fill { fill: #ffffff; }

  /* Buttons */
  .btn {
    display: inline-flex; align-items: center; justify-content: center;
    padding: 18px 36px; border-radius: 16px; font-size: 17px; font-weight: 800;
    text-decoration: none; border: none; cursor: pointer;
    transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    position: relative; overflow: hidden;
  }
  .btn span { position: relative; z-index: 2; }
  .btn:hover { transform: translateY(-5px) scale(1.02); }
  .btn:active { transform: translateY(2px) scale(0.98); }
  
  .shiny-btn::after, .shiny-btn-light::after {
    content: ''; position: absolute; top: -50%; left: -50%; width: 200%; height: 200%;
    transform: rotate(45deg); z-index: 1;
  }
  .shiny-btn::after { background: linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,0.2) 50%, rgba(255,255,255,0) 100%); animation: shine 3s infinite; }
  .shiny-btn-light::after { background: linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,0.5) 50%, rgba(255,255,255,0) 100%); animation: shine 3s infinite 1s; }

  .btn-dark { background: #1c1c1c; color: white; box-shadow: 0 15px 30px rgba(0,0,0,0.2); border: 1px solid #333; }
  .btn-dark:hover { box-shadow: 0 20px 40px rgba(0,0,0,0.3); background: #000; }
  
  .btn-glass { background: rgba(255,255,255,0.2); backdrop-filter: blur(10px); border: 1px solid rgba(255,255,255,0.5); color: #ffffff; box-shadow: 0 15px 30px rgba(0,0,0,0.1); }
  .btn-glass:hover { background: rgba(255,255,255,0.3); color: white; border-color: white; }
  
  .btn-primary { background: linear-gradient(135deg, #ff6b00, #ff4500); color: white; box-shadow: 0 15px 30px rgba(255,107,0,0.3); border: 1px solid #ff5200; }
  .btn-primary:hover { box-shadow: 0 20px 40px rgba(255,107,0,0.4); }
  .bouncy-btn { animation: pulseGlow 2s infinite; }

  /* Sections */
  .section { padding: 120px 5%; position: relative; z-index: 10; }
  .section-container { max-width: 1200px; margin: 0 auto; position: relative; }
  .bg-white { background: #ffffff; }
  .bg-gradient-light { background: linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%); }
  
  .bg-orange-pattern { background: linear-gradient(135deg, #fff0e6, #ffebd9); position: relative; overflow: hidden; }
  .bg-orange-pattern::before { content: ''; position: absolute; width: 200%; height: 200%; top: -50%; left: -50%; background-image: radial-gradient(#ff6b00 1px, transparent 1px); background-size: 40px 40px; opacity: 0.05; transform: rotate(15deg); }
  
  .section-title { font-size: clamp(32px, 5vw, 48px); font-weight: 900; text-align: center; margin-bottom: 60px; color: #1c1c1c; letter-spacing: -1px; }

  /* Why Bakalia Section Styles */
  .why-bakalia-container {
    background: rgba(255, 255, 255, 0.9); backdrop-filter: blur(15px); border-radius: 32px; padding: 60px;
    box-shadow: 0 20px 50px rgba(255,107,0,0.1); border: 1px solid rgba(255,107,0,0.15); max-width: 900px; margin: 0 auto; text-align: center;
  }
  .mission-badge {
    display: inline-block; background: rgba(255,107,0,0.1); border: 1px solid rgba(255,107,0,0.2); padding: 8px 20px; border-radius: 30px;
    color: #ff6b00; font-weight: 800; font-size: 14px; margin-bottom: 24px; text-transform: uppercase; letter-spacing: 1px;
  }
  .mission-title { font-size: clamp(28px, 4vw, 42px); font-weight: 900; color: #1c1c1c; margin-bottom: 30px; letter-spacing: -1px; line-height: 1.2; }
  .mission-text { font-size: 18px; line-height: 1.8; color: #4a4a4a; margin-bottom: 20px; }
  .mission-highlight { font-size: 20px; font-weight: 800; color: #ff6b00; margin-top: 30px; background: linear-gradient(135deg, #ff6b00, #ff2a00); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }

  /* Cards with intensive hover animations */
  .animated-card { transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275); position: relative; z-index: 1; overflow: hidden; opacity: 0; animation: fadeInUp 0.8s forwards; }
  .animated-card:hover { transform: translateY(-15px) scale(1.03); z-index: 2; }
  .card-glow { position: absolute; width: 100px; height: 100px; background: radial-gradient(circle, rgba(255,107,0,0.1) 0%, transparent 70%); bottom: -50px; right: -50px; border-radius: 50%; transition: all 0.4s; z-index: -1; }
  .animated-card:hover .card-glow { transform: scale(4); opacity: 1; }
  
  .card-glow-orange { position: absolute; width: 150px; height: 150px; background: radial-gradient(circle, rgba(255,107,0,0.15) 0%, transparent 70%); top: -50px; right: -50px; border-radius: 50%; transition: all 0.5s; z-index: -1; }
  .glass-card:hover .card-glow-orange { transform: scale(5); opacity: 1; }

  /* Features Grid */
  .features-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap: 30px; }
  .feature-card { background: #ffffff; padding: 40px 30px; border-radius: 24px; box-shadow: 0 10px 30px rgba(0,0,0,0.04); border: 1px solid rgba(0,0,0,0.03); }
  .feature-card:hover { box-shadow: 0 20px 40px rgba(255,107,0,0.1); border-color: rgba(255,107,0,0.2); }
  .feature-icon { font-size: 40px; background: #fff0e6; width: 80px; height: 80px; display: flex; align-items: center; justify-content: center; border-radius: 20px; margin-bottom: 24px; transition: transform 0.3s; }
  .feature-card:hover .feature-icon { transform: scale(1.1) rotate(5deg); background: #ff6b00; color: white; text-shadow: 0 0 10px rgba(255,255,255,0.5); }
  .feature-title { font-size: 22px; font-weight: 800; margin-bottom: 12px; }
  .feature-text { font-size: 15px; color: #686b78; margin: 0; line-height: 1.6; }

  /* Partners Grid */
  .partners-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(320px, 1fr)); gap: 30px; }
  .partner-card { background: rgba(255,255,255,0.8); backdrop-filter: blur(20px); -webkit-backdrop-filter: blur(20px); padding: 50px 40px; border-radius: 28px; box-shadow: 0 15px 35px rgba(0,0,0,0.05); border: 1px solid rgba(255,255,255,0.6); }
  .partner-card:hover { box-shadow: 0 25px 50px rgba(255,107,0,0.15); border-color: #ff6b00; }
  .partner-emoji { font-size: 56px; margin-bottom: 24px; display: inline-block; }
  .partner-title { font-size: 28px; font-weight: 800; margin-bottom: 16px; }
  .partner-text { font-size: 16px; color: #686b78; margin-bottom: 35px; min-height: 48px; line-height: 1.7; }
  .btn-text { display: inline-flex; align-items: center; gap: 8px; color: #ff6b00; font-weight: 800; text-decoration: none; font-size: 17px; padding: 12px 24px; background: #fff0e6; border-radius: 12px; transition: all 0.3s; }
  .btn-text:hover { background: #ff6b00; color: white; }
  .arrow-move { transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275); }
  .btn-text:hover .arrow-move { transform: translateX(8px); }

  /* Download Area */
  .download-container { max-width: 700px; padding: 60px 40px; background: #fffaf5; border-radius: 40px; border: 1px solid #ffeadd; box-shadow: 0 20px 50px rgba(255,107,0,0.08); position: relative; overflow: hidden; }
  .hover-lift { transition: transform 0.4s; }
  .hover-lift:hover { transform: translateY(-10px); }
  .download-blob { position: absolute; width: 300px; height: 300px; background: #ffebd9; border-radius: 50%; filter: blur(40px); top: -100px; right: -100px; z-index: 0; animation: float 10s infinite; }
  .download-container * { position: relative; z-index: 2; }
  .download-subtitle { font-size: 20px; color: #4a4a4a; margin-bottom: 40px; }

  /* Footer */
  .footer { background: #0a0a0a; color: #ffffff; padding: 80px 5% 40px 5%; text-align: center; position: relative; overflow: hidden; }
  .footer::before { content: ''; position: absolute; top: 0; left: 0; right: 0; height: 4px; background: linear-gradient(90deg, #ff8a00, #ff0055, #ff8a00); background-size: 200% auto; animation: textGradient 3s linear infinite; }
  .footer-email { font-size: 16px; color: #a0a0a0; margin-bottom: 40px; font-weight: 600; cursor: pointer; transition: color 0.3s; }
  .hover-text-glow:hover { color: #ff6b00; text-shadow: 0 0 15px rgba(255,107,0,0.5); }
  .footer-links { display: flex; justify-content: center; align-items: center; gap: 20px; flex-wrap: wrap; margin-bottom: 40px; }
  .footer-links a { color: #d4d5d9; text-decoration: none; font-size: 15px; font-weight: 600; transition: all 0.2s; position: relative; }
  .footer-links a::after { content: ''; position: absolute; width: 0; height: 2px; bottom: -4px; left: 0; background: #ff6b00; transition: width 0.3s; }
  .footer-links a:hover { color: #ffffff; }
  .footer-links a:hover::after { width: 100%; }
  .dot { color: #4a4a4a; }
  .footer-copyright { font-size: 14px; color: #666666; border-top: 1px solid #222222; padding-top: 40px; font-weight: 500; }

  /* Mobile Adjustments */
  @media (max-width: 768px) {
    .nav-links { display: none; }
    .hero-section { padding-top: 80px; min-height: 80vh; }
    .hero-title { font-size: 44px; }
    .hero-buttons { flex-direction: column; width: 100%; }
    .btn { width: 100%; }
    .section { padding: 80px 5%; }
    .why-bakalia-container { padding: 40px 20px; }
    .mission-title { font-size: 24px; }
    .mission-text { font-size: 16px; }
    .floating-foods-container { opacity: 0.3; /* Tame it slightly for small screens */ }
    .download-container { padding: 40px 20px; }
    .hero-video-container { width: 150px; height: 150px; }
  }
`;

export default LandingPage;